/**
 * Seeds supplied to the deterministic generator are themselves non-deterministic
 * — they're either user-typed or randomly minted for "Regenerate". This lives
 * OUTSIDE src/generator/ so it doesn't trip the no-Math.random lint rule.
 */
export function randomSeed(): string {
  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    const buf = new Uint32Array(2);
    globalThis.crypto.getRandomValues(buf);
    return `${buf[0]!.toString(36)}${buf[1]!.toString(36)}`;
  }
  // Non-browser fallback (tests running in jsdom always have crypto,
  // so this path is exercised only in unusual environments).
  const a = Math.floor(Math.random() * 0xffffffff);
  const b = Math.floor(Math.random() * 0xffffffff);
  return `${a.toString(36)}${b.toString(36)}`;
}

/** Human-friendly seed validator — keep the surface small so URLs are stable. */
export function normalizeSeed(input: string): string {
  const cleaned = input.trim().toLowerCase().replace(/[^a-z0-9:_-]/g, '');
  return cleaned || randomSeed();
}
